import { DetailTicket, SelectOption } from "../../../types/models/ticket.model.type";
import {
  CancelTicketRequest,
  CloseTicketRequest,
  DetailTicketRequest,
  GetModulesRequest,
  GetRequirementRequest,
  PendingTicketsClosedRequest,
  ReassignTicketRequest,
  RejectTicketRequestAp,
  RejectTicketRequestAt,
  SolveTicketRequest,
} from "../../../types/request/ticket.request.type";
import {
  CancelTicketResponse,
  CloseTicketResponse,
  PendingTicketsClosedResponse,
  ReassignTicketResponse,
  RejectTicketResponse,
  SolveTicketResponse,
} from "../../../types/response/ticket.response.type";
import { GET, POST } from "../../../utils/enum/requestMethods.enum";
import { HelpDeskApiRoutes } from "../../../utils/mapping/apiRoutes.mapping";
import { reduxApiService } from "../../services/reduxApi.service";

const sharedTicketsApi = reduxApiService.injectEndpoints({
  endpoints: (build) => ({
    closeTicket: build.mutation<CloseTicketResponse, CloseTicketRequest>({
      query: (requestParams) => ({
        url: HelpDeskApiRoutes.closeTicket,
        method: GET,
        params: { ...requestParams },
      }),
    }),
    getReasonsCancellation: build.query<SelectOption[], void>({
      query: () => ({
        url: HelpDeskApiRoutes.getReasonsCancellation,
        method: GET,
      }),
    }),
    getReassignmentPartners: build.query<SelectOption[], void>({
      query: () => ({
        url: HelpDeskApiRoutes.getReassignmentPartners,
        method: GET,
      }),
    }),
    rejectTicketAp: build.mutation<RejectTicketResponse, RejectTicketRequestAp>({
      query: (params) => ({
        url: HelpDeskApiRoutes.rejectTicketAp,
        method: POST,
        body: { ...params },
      }),
    }),
    rejectTicketAt: build.mutation<RejectTicketResponse, RejectTicketRequestAt>({
      query: (params) => ({
        url: HelpDeskApiRoutes.rejectTicketAt,
        method: POST,
        body: { ...params },
      }),
    }),
    reassignTicket: build.mutation<ReassignTicketResponse, ReassignTicketRequest>({
      query: (params) => ({
        url: HelpDeskApiRoutes.reassignTicket,
        method: GET,
        params: { ...params },
      }),
    }),
    solveTicket: build.mutation<SolveTicketResponse, SolveTicketRequest>({
      query: (params) => ({
        url: HelpDeskApiRoutes.solveTicket,
        method: POST,
        body: { ...params },
      }),
    }),
    getSupportItems: build.query<SelectOption[], void>({
      query: () => ({
        url: HelpDeskApiRoutes.getSupportItems,
        method: GET,
      }),
    }),
    getModules: build.mutation<SelectOption[], GetModulesRequest>({
      query: (params) => ({
        url: HelpDeskApiRoutes.getModuleSystems,
        method: GET,
        params: { ...params },
      }),
    }),
    getRequirements: build.mutation<SelectOption[], GetRequirementRequest>({
      query: (params) => ({
        url: HelpDeskApiRoutes.getRequirements,
        method: GET,
        params: { ...params },
      }),
    }),
    getDetailTicket: build.mutation<DetailTicket[], DetailTicketRequest>({
      query: (requestParams) => ({
        url: HelpDeskApiRoutes.detailTicket,
        method: GET,
        params: { ...requestParams },
      }),
    }),
    cancelTicket: build.mutation<CancelTicketResponse, CancelTicketRequest>({
      query: (params) => ({
        url: HelpDeskApiRoutes.cancelTicket,
        method: POST,
        body: { ...params },
      }),
    }),
    pendingTicketsClosed: build.mutation<PendingTicketsClosedResponse, PendingTicketsClosedRequest>({
      query: (requestParams) => ({
        url: HelpDeskApiRoutes.pendingTicketsClosed,
        method: GET,
        params: { ...requestParams },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCloseTicketMutation,
  useGetReasonsCancellationQuery,
  useRejectTicketApMutation,
  useRejectTicketAtMutation,
  useGetReassignmentPartnersQuery,
  useReassignTicketMutation,
  useSolveTicketMutation,
  useGetSupportItemsQuery,
  useGetModulesMutation,
  useGetRequirementsMutation,
  useGetDetailTicketMutation,
  useCancelTicketMutation,
  usePendingTicketsClosedMutation,
} = sharedTicketsApi;
